module.exports = __webpack_public_path__ + "static/media/avatar.0bd6ef45.jpg";